<div [ngClass]="type">
    <div *ngIf="!readOnly" class="form-group compact inline-control">
        <ng-content select="div[role=header]"></ng-content>
          <dx-select-box class="compactSelectBox"
                         displayExpr="displayValue"
                         [dataSource]="dropdownItems"
                         [(ngModel)]="selectedListItem"
                         [searchMode]="searchModeOption"
                         [searchExpr]="searchExprOption"
                         [searchTimeout]="searchTimeoutOption"
                         [minSearchLength]="minSearchLengthOption"
                         [searchEnabled]="true"
                         [disabled]="readOnly">
          </dx-select-box>
          <button type="button" class="compact" (click)="onAdd()" [disabled]="readOnly">
              <span class="icon-plus"></span> {{acceptText}}
          </button>
    </div>
    <div  *ngIf="!readOnly" class="warning info">* To reorder drag and drop your {{infoLabel}}.</div>
    <ng-content select="ul[role=list]"></ng-content>
    <table role="list"class="condensed">
        <thead>
            <tr>
                <th *ngFor="let column of columns">{{column}}</th>
                <th><span class="offscreen"></span></th>
            </tr>
        </thead>
        <tbody  *ngIf="!readOnly" cdkDropList (cdkDropListDropped)="drop($event)">
            <tr *ngFor="let row of rows" class="compact" cdkDrag >
                <td><span>{{row.order==0?'':row.order}}</span></td>
                <td *ngFor="let cell of row.cells" >
                    <select *ngIf="cell.type == 'list'" [ngClass]="{'required-error': cell.value==''}"
                        class="compact"
                        id="dropDownItemList"
                        [(ngModel)]="cell.value"
                        [disabled]="readOnly || skipRowUpdate"
                        (change)="onCellChange(cell.id, row.id, $event.target.value)">
                        <option *ngFor="let option of cell.options" [value]="option">{{option}}</option>
                    </select>
                    <input *ngIf="cell.type == 'checkBox'"
                        type="checkbox"
                        class="compact"
                        name="checkbox-{{ row.id }}"
                        [disabled]="readOnly || cell.readOnly || skipRowUpdate"
                        (change)="onCellChange(cell.id, row.id, $event.target.checked)"
                        [checked]="cell.value">
                    <div *ngIf="!cell.type">{{ cell.value }}</div>
                </td>
                <td><button *ngIf="!readOnly" type="button" class="compact" id="{{row.id}}" (click)="onRemove(row.id)" [disabled]="readOnly"><span  class="icon-bin"></span> Remove</button></td>
            </tr>
        </tbody>
        <tbody  *ngIf="readOnly">
            <tr *ngFor="let row of rows" class="compact" >
                <td><span>{{row.order==0?'':row.order}}</span></td>
                <td *ngFor="let cell of row.cells" >
                    <select *ngIf="cell.type == 'list'" [ngClass]="{'required-error': cell.value==''}"
                        class="compact"
                        id="dropDownItemList"
                        [(ngModel)]="cell.value"
                        [disabled]="readOnly || skipRowUpdate"
                        (change)="onCellChange(cell.id, row.id, $event.target.value)">
                        <option *ngFor="let option of cell.options" [value]="option">{{option}}</option>
                    </select>
                    <input *ngIf="cell.type == 'checkBox'"
                        type="checkbox"
                        class="compact"
                        name="checkbox-{{ row.id }}"
                        [disabled]="readOnly || cell.readOnly || skipRowUpdate"
                        (change)="onCellChange(cell.id, row.id, $event.target.checked)"
                        [checked]="cell.value">
                    <div *ngIf="!cell.type">{{ cell.value }}</div>
                </td>
                <td><button *ngIf="!readOnly" type="button" class="compact" id="{{row.id}}" (click)="onRemove(row.id)" [disabled]="readOnly"><span  class="icon-bin"></span> Remove</button></td>
            </tr>
        </tbody>
    </table>
</div>
